import { useRef } from "react";
import { Link } from "react-router-dom";
import { Chapter, Reveal } from "@/components/aklive/motion";
import { PlaceholderBlock } from "@/components/aklive/PlaceholderBlock";

const PROJECTS = ["Proof of Talk", "Midas Capital", "VNX", "Puretive", "Salted Social", "Meducan"];

export const WorkProof = () => {
  const trackRef = useRef(null);
  const scrollByAmount = (dir) => trackRef.current?.scrollBy({ left: dir * 420, behavior: "smooth" });

  return (
    <section className="py-24 md:py-40" data-testid="workproof-section">
      <div className="container-ak">
        <Chapter index="06" label="Work Proof" />
        <div className="mb-10 flex items-end justify-between md:mb-14">
          <Reveal>
            <h2 className="font-display text-4xl font-bold leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl">
              Selected work<span className="text-ember">.</span>
            </h2>
          </Reveal>
          <div className="hidden gap-3 md:flex">
            <button
              type="button"
              aria-label="Scroll gallery left"
              data-testid="workproof-prev-btn"
              onClick={() => scrollByAmount(-1)}
              className="flex h-11 w-11 items-center justify-center border border-line text-ink transition-colors duration-300 hover:border-ink"
            >
              ←
            </button>
            <button
              type="button"
              aria-label="Scroll gallery right"
              data-testid="workproof-next-btn"
              onClick={() => scrollByAmount(1)}
              className="flex h-11 w-11 items-center justify-center border border-line text-ink transition-colors duration-300 hover:border-ink"
            >
              →
            </button>
          </div>
        </div>
      </div>

      <Reveal>
        <div
          ref={trackRef}
          data-testid="workproof-gallery"
          className="no-scrollbar flex snap-x snap-mandatory gap-6 overflow-x-auto scroll-pl-5 px-5 pb-4 sm:scroll-pl-8 sm:px-8 lg:scroll-pl-12 lg:px-12"
        >
          {PROJECTS.map((name, i) => (
            <article
              key={name}
              data-testid={`workproof-item-${i}`}
              className="group w-[75vw] flex-shrink-0 snap-start sm:w-[380px]"
            >
              <div className="overflow-hidden">
                <PlaceholderBlock
                  label="[PROJECT COVER — 4:5]"
                  ratio="4 / 5"
                  className="transition-transform duration-500 ease-out group-hover:scale-[1.03]"
                />
              </div>
              <div className="mt-5 flex items-baseline gap-4">
                <span className="font-mono text-[10px] tracking-[0.2em] text-ember">0{i + 1}</span>
                <h3 className="font-display text-2xl font-bold tracking-tight text-ink">{name}</h3>
              </div>
              <dl className="mt-3 space-y-1 pl-8 font-mono text-[10px] uppercase tracking-[0.18em] text-ink2">
                <div className="flex gap-3">
                  <dt>Industry</dt>
                  <dd>[INDUSTRY]</dd>
                </div>
                <div className="flex gap-3">
                  <dt>Contribution</dt>
                  <dd>[CONTRIBUTION — ONE LINE]</dd>
                </div>
              </dl>
            </article>
          ))}
        </div>
      </Reveal>

      <div className="container-ak mt-10 md:mt-14">
        <Link
          to="/work"
          data-testid="workproof-view-work-link"
          className="link-underline inline-flex items-center gap-3 font-display text-lg font-bold tracking-tight text-ink hover:text-ember"
        >
          View Our Work <span aria-hidden="true">→</span>
        </Link>
      </div>
    </section>
  );
};
